import { useEffect } from "react";
import { Header } from "../../widgets";
import LoginForm from "../../widgets/loginForm/LoginForm";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../stateManagement/hooks/redux";
import { setFullConfig, setFullConfigIsLoading } from "../../stateManagement/reducers";
import { Loader } from "../../widgets/loaders/Loader";
import { fetchFullConfig } from "../../api/configApi";
import { setItemLocalStorage } from "../../features/webStorageSaver";
import ToastMessageContainer from "../../widgets/toastMessageContainer/ToastMessageContainer";

export default function LoginPage() {
    const dispatch = useDispatch()
    const { loginFormIsLoading } = useAppSelector(state => state.login)

    async function getFullConfig() {
        dispatch(setFullConfigIsLoading(true))
        const fullConfig = await fetchFullConfig()
        if (fullConfig) {
            dispatch(setFullConfig(fullConfig))
            setItemLocalStorage("fullConfig", fullConfig)
        }
        dispatch(setFullConfigIsLoading(false))
    }

    useEffect(() => {
        getFullConfig()
    }, [])

    return (
        <>
            <Header type="login" />
            {loginFormIsLoading && <Loader />}
            <div className="login-page-div">
                <ToastMessageContainer position="bottom-center" />
                <div className="login-form-div">
                    <div className="login-form-header">Войти</div>
                    <LoginForm />
                </div>
            </div>
        </>
    )
}
